import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../component/layout';
import { toastify } from '../../../utils/toast';
import { makeRequest2 } from '../../../utils/makeRequest';
import { getItem } from '../../../utils/localStorage';
import { getAssignedTicketsURL } from '../../../utils/urls';

const AssignedTickets = () => {
    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const fetchAssignedTickets = async () => {
        try {
            const facilityId = await getItem('selectedFacilityId');
            const userId = await getItem('userId');

            const response = await makeRequest2(`${getAssignedTicketsURL}/${facilityId}/${userId}`, 'GET', {});
            console.log("Response tickets", response)

            if (response.success) {
                setTickets(response.data.data);
            } else {
                throw new Error(response.message || 'Failed to fetch assigned tickets');
            }
        } catch (err) {
            toastify(err.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAssignedTickets();
    }, []);

    const handleViewTicket = (ticketId) => {
        navigate(`/facility/ticket_management/view_ticket/${ticketId}`);
    };

    const getStatusBadge = (status) => {
        const statusConfig = {
            'assigned': { class: 'bg-warning text-dark', label: 'Assigned' },
            'under review': { class: 'bg-info', label: 'Under Review' },
            'ongoing': { class: 'bg-primary', label: 'Ongoing' },
            'resolved': { class: 'bg-success', label: 'Resolved' }
        };

        const config = statusConfig[status] || { class: 'bg-secondary', label: status };
        return <span className={`badge ${config.class}`}>{config.label}</span>;
    };

    const getPriorityBadge = (priority) => {
        const priorityConfig = {
            'High': 'bg-danger',
            'Medium': 'bg-warning text-dark',
            'Low': 'bg-success'
        };

        return <span className={`badge ${priorityConfig[priority] || 'bg-secondary'}`}>{priority}</span>;
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <Layout>
            <div className="container-fluid py-4">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-header">
                                <h5 className="mb-0">
                                    <i className="fas fa-tasks me-2 text-primary"></i> My Assigned Tickets
                                </h5>
                                <p className="text-muted mb-0">
                                    Tickets assigned to you for review and action
                                </p>
                            </div>

                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-12 col-xxl-12">
                                        <div className="card">
                                            <div className="card-body position-relative">
                                                <div className="d-flex justify-content-end mb-3">
                                                    <span className="badge bg-primary fs-6">
                                                        {tickets.length} tickets
                                                    </span>
                                                </div>

                                                {tickets.length === 0 ? (
                                                    <div className="card border">
                                                        <div className="card-body text-center py-5">
                                                            <i className="fas fa-inbox fa-3x text-muted mb-3"></i>
                                                            <h4 className="text-muted">No Assigned Tickets</h4>
                                                            <p className="text-muted">
                                                                You don't have any tickets assigned to you at the moment.
                                                            </p>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="row">
                                                        {tickets.map((ticket) => (
                                                            <div key={ticket._id} className="col-lg-6 col-xl-4 mb-4">
                                                                <div className="card border h-100 shadow-sm">
                                                                    <div className="card-header bg-light border-bottom">
                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                            <h6 className="mb-0 text-dark">
                                                                                Ticket #{ticket.ticketNumber}
                                                                            </h6>
                                                                            {getStatusBadge(ticket.status)}
                                                                        </div>
                                                                    </div>

                                                                    <div className="card-body">
                                                                        <h6 className="card-title text-dark">{ticket.subject}</h6>
                                                                        <p className="card-text text-muted small mb-3">
                                                                            {ticket.description?.substring(0, 100)}
                                                                            {ticket.description?.length > 100 && '...'}
                                                                        </p>

                                                                        <div className="mb-3">
                                                                            <div className="row g-2 small">
                                                                                <div className="col-6">
                                                                                    <strong>Type:</strong>
                                                                                    <div className="text-muted">{ticket.ticketType}</div>
                                                                                </div>
                                                                                <div className="col-6">
                                                                                    <strong>Priority:</strong>
                                                                                    <div>{getPriorityBadge(ticket.priority)}</div>
                                                                                </div>
                                                                                <div className="col-6">
                                                                                    <strong>Raised By:</strong>
                                                                                    <div className="text-muted">
                                                                                        {ticket.requesterInfo?.fullName || 'Unknown'}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-6">
                                                                                    <strong>Date:</strong>
                                                                                    <div className="text-muted">
                                                                                        {new Date(ticket.date).toLocaleDateString()}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="card-footer bg-transparent border-top">
                                                                        <div className="d-grid">
                                                                            <button
                                                                                className="btn btn-primary btn-sm"
                                                                                onClick={() => handleViewTicket(ticket._id)}
                                                                            >
                                                                                <i className="fas fa-eye me-2"></i> View Details
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </Layout>

    );
};

export default AssignedTickets;